import OrgTextField from "@material-ui/core/TextField";
import React, { useCallback, useEffect, useState } from "react";
import { FieldRenderProps } from "react-final-form";

interface TextFieldProps extends FieldRenderProps<any> {
  autoComplete?: boolean;
  type?: string;
}

export const TextFieldComponent = (props: TextFieldProps) => {
  const {
    input: { name, onChange, value, ...restInput },
    readOnly,
    meta,
    autoComplete,
    type,
    multiline,
    rows
  } = props;
  const [isTypePassword, setIsTypePassword] = useState(false);

  useEffect(() => {
    if (type === "password" && !autoComplete) {
      setIsTypePassword(true);
    }
  }, []);

  const checkPropType = useCallback((): string => {
    if (isTypePassword) {
      return value === "" ? "text" : "password";
    } else {
      return type ? type : "text";
    }
  }, []);

  return (
    <>
      <OrgTextField
        name={name}
        helperText={
          meta.visited || meta.touched
            ? meta.error || meta.submitError
            : undefined
        }
        error={(meta.error || meta.submitError) && meta.touched}
        inputProps={{ ...restInput }}
        onChange={onChange}
        value={value}
        type={checkPropType()}
        variant="outlined"
        disabled={readOnly}
        fullWidth={true}
        margin="dense"
        multiline={multiline}
        rows={rows}
      />
      {!autoComplete && type !== "password" && !isTypePassword && (
        <input
          name={name + "_hidden"}
          onChange={onChange}
          value={value}
          style={{ display: "none" }}
        />
      )}
    </>
  );
};
